import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import axios from "axios";
import { PulseLoader } from "react-spinners";
import "../../assets/css/style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-regular-svg-icons";
import Header from "../Header/HeaderOTM";
import { APILA } from "../../config/apila";
import { APIMS } from "../../config/apims";

// const API_URL = "https://api.la.sims.alazharsummarecon.sch.id/api/angket-otm/questions";
// const API_SAVE_BASE = "https://api.la.sims.alazharsummarecon.sch.id/api/angket-otm";

// const RATING_OPTIONS = [
//   { value: 1, label: "Belum Terbiasa" },
//   { value: 2, label: "Mulai Terbiasa" },
//   { value: 3, label: "Terbiasa" },
//   { value: 4, label: "Sangat Terbiasa" },
// ];

const RATING_OPTIONS = [
  { value: 1, label: "Jarang" },
  { value: 2, label: "Kadang" },
  { value: 3, label: "Sering" },
  { value: 4, label: "Selalu" },
];

function buildSectionsFromApiQuestions(questions = []) {
  // API: questions[] -> dimensi -> elements[] -> sub_elements[]
  // Kita jadikan "section per element" agar subtitle = element.description
  return (questions || []).flatMap((dimensi) => {
    const sectionName = dimensi?.name_dimensi || "-";
    const elements = dimensi?.elements || [];
    return elements.map((el) => {
      const subtitle = el?.description || "-";
      const items = (el?.sub_elements || []).map((se) => ({
        // untuk state jawaban, gunakan ysb_sub_element_id agar unik
        key: se?.ysb_sub_element_id,
        id: se?.id, // "default" atau id lainnya dari server
        ysb_sub_element_id: se?.ysb_sub_element_id,
        ysb_sub_element_value: se?.ysb_sub_element_value,
        is_answered: se?.is_answered,
        title: se?.ysb_sub_element_name,
      }));

      return {
        section: sectionName,
        subtitle,
        ysb_dimensi_id: dimensi?.ysb_dimensi_id,
        ysb_element_id: el?.ysb_element_id,
        items,
      };
    });
  });
}

export default function FormOrangTua() {
  const navigate = useNavigate();
  document.title = "Form Angket Orang Tua";

  const [step, setStep] = useState(0);

  // Loading halaman & aksi tombol
  const [loadingPage, setLoadingPage] = useState(true);
  const [loadingAction, setLoadingAction] = useState(null); // draft | submit

  // loading per jawaban (auto-save)
  const [savingMap, setSavingMap] = useState({}); // { [ysb_sub_element_id]: true/false }

  // data dari API
  const [apiStudentInfo, setApiStudentInfo] = useState(null);
  const [apiProgress, setApiProgress] = useState(null);
  const [sections, setSections] = useState([]); // hasil mapping
  const [activeSemesterId, setActiveSemesterId] = useState("");

  // jawaban: key = ysb_sub_element_id, value = 1..4
  const [answers, setAnswers] = useState({});
  const [catatan, setCatatan] = useState("");

  // === highlight pertanyaan kosong + scroll ===
  const [showMissingMark, setShowMissingMark] = useState(false);
  const [pendingScrollId, setPendingScrollId] = useState(null); // ysb_sub_element_id yang mau di-scroll
  const questionRefs = useRef({}); // { [ysb_sub_element_id]: HTMLElement }

  // modal konfirmasi kirim
  const [confirmModal, setConfirmModal] = useState({
    open: false,
    title: "",
    message: "",
    onConfirm: null,
  });

  // ambil data anak dari localStorage (kalau ada)
  const childProfile = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("student_profile") || "{}");
    } catch {
      return {};
    }
  }, []);

  const parentProfile = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("parent_profile") || "{}");
    } catch {
      return {};
    }
  }, []);

  const namaOrtu = parentProfile?.nama_orang_tua || "Orang Tua";
  const roleOrtu = parentProfile?.hubungan || "Wali Murid";

  // header auth (sesuaikan dengan penyimpanan token kamu)
  const getAuthHeaders = () => {
    const token =
      localStorage.getItem("token") ||
      localStorage.getItem("access_token") ||
      localStorage.getItem("auth_token");

    // Kalau API kamu pakai header lain (mis. X-API-KEY), tambahin di sini.
    return {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
  };

  const [modalNotif, setModalNotif] = useState({
    open: false,
    type: "sukses", // sukses | info | peringatan
    title: "",
    message: "",
    onConfirm: null,
  });

  const bukaModal = ({ type = "info", title = "", message = "", onConfirm = null }) => {
    setModalNotif({ open: true, type, title, message, onConfirm });
  };

  const tutupModal = () => {
    setModalNotif({ open: false, type: "info", title: "", message: "", onConfirm: null });
  };

  const bukaConfirm = ({ title = "Konfirmasi", message = "", onConfirm = null }) => {
    setConfirmModal({ open: true, title, message, onConfirm });
  };

  const tutupConfirm = () => {
    setConfirmModal({ open: false, title: "", message: "", onConfirm: null });
  };

  const fetchActiveSemester = async () => {
  try {
    const res = await APIMS.get("/api/access/semesters", {
      headers: getAuthHeaders(),
      params: {
        page: 1,
        limit: 100,
        ascending: 0,
      },
    });

    const semesters = res?.data?.data || [];

    const activeSemester = semesters.find(
      (item) => Number(item?.status) === 1
    );

    if (activeSemester?.id) {
      setActiveSemesterId(activeSemester.id);
      localStorage.setItem("ysb_semester_id", activeSemester.id);
      return activeSemester.id;
    }

    return (
      localStorage.getItem("ysb_semester_id") ||
      childProfile?.ysb_semester_id ||
      ""
    );
  } catch (err) {
    console.error("Gagal load semester aktif:", err);

    return (
      localStorage.getItem("ysb_semester_id") ||
      childProfile?.ysb_semester_id ||
      ""
    );
  }
};

  const fetchQuestions = async () => {
    setLoadingPage(true);
    try {
     
      const semesterIdAktif = await fetchActiveSemester();

const params = {
  ysb_student_id:
    childProfile?.ysb_student_id ||
    localStorage.getItem("ysb_student_id") ||
    "",
  ysb_semester_id: semesterIdAktif,
  ysb_grade_level_id:
    childProfile?.ysb_grade_level_id ||
    localStorage.getItem("ysb_grade_level_id") ||
    "",
  ysb_school_id:
    childProfile?.ysb_school_id ||
    localStorage.getItem("ysb_school_id") ||
    "",
};

      // const res = await APILA.get(
      //           "/api/dashboard-otm",

      const res = await APILA.get("/api/angket-otm/questions", {
        headers: getAuthHeaders(),
        params, // ✅ GET pakai params
      });

      const data = res?.data?.data;
      const studentInfo = data?.student_info || null;
      const progress = data?.progress || null;
      const questions = data?.questions || [];

      const mappedSections = buildSectionsFromApiQuestions(questions);

      // prefill answers dari ysb_sub_element_value jika ada
      const initialAnswers = {};
      mappedSections.forEach((sec) => {
        (sec.items || []).forEach((it) => {
          if (it?.ysb_sub_element_value !== null && it?.ysb_sub_element_value !== undefined) {
            initialAnswers[it.ysb_sub_element_id] = Number(it.ysb_sub_element_value);
          }
        });
      });

      setApiStudentInfo(studentInfo);
      setApiProgress(progress);
      setSections(mappedSections);
      setAnswers(initialAnswers);
      setStep(0);

      // reset highlight saat reload data
      setShowMissingMark(false);
      setPendingScrollId(null);
      questionRefs.current = {};
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "Gagal memuat pertanyaan. Silakan coba lagi.";
      bukaModal({
        type: "peringatan",
        title: "Gagal Memuat Data",
        message: msg,
      });
      setSections([]);
    } finally {
      setLoadingPage(false);
    }
  };

  useEffect(() => {
    fetchQuestions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const totalQuestions = useMemo(() => {
    return (sections || []).reduce((acc, s) => acc + (s?.items?.length || 0), 0);
  }, [sections]);

  const answeredCount = useMemo(() => {
    return Object.keys(answers || {}).length;
  }, [answers]);

  const isFirstStep = step === 0;
  const isLastStep = step === (sections?.length || 1) - 1;

  const currentSection = sections?.[step];
  const progressPercent = sections?.length ? ((step + 1) / sections.length) * 100 : 0;

  const namaAnak = apiStudentInfo?.nama_siswa || childProfile?.nama_siswa || "Nama Anak";
  const nisnAnak = apiStudentInfo?.nisn || localStorage.getItem("nisn") || "-";
  const namaKelas = apiStudentInfo?.nama_kelas || "-";

  const sectionAnswered = useMemo(() => {
    if (!currentSection?.items?.length) return 0;
    return currentSection.items.filter((q) => answers?.[q.ysb_sub_element_id]).length;
  }, [currentSection, answers]);

  // === Helpers update id item di sections (agar setelah create default, lanjut update by ID) ===
  const updateItemIdInSections = (ysbSubElementId, newId) => {
    setSections((prev) =>
      (prev || []).map((sec) => ({
        ...sec,
        items: (sec.items || []).map((it) =>
          it.ysb_sub_element_id === ysbSubElementId ? { ...it, id: newId } : it
        ),
      }))
    );
  };

  const buildSavePayload = ({ item, value, section }) => {
    // Ambil dari API student_info dulu, fallback ke localStorage profile
    const ysb_student_id = apiStudentInfo?.ysb_student_id || childProfile?.ysb_student_id || "";
    const payload = {
      ysb_branch_id:
        apiStudentInfo?.ysb_branch_id ||
        childProfile?.ysb_branch_id ||
        localStorage.getItem("ysb_branch_id") ||
        "",
      ysb_school_id:
        apiStudentInfo?.ysb_school_id ||
        childProfile?.ysb_school_id ||
        localStorage.getItem("ysb_school_id") ||
        "",
      // ysb_semester_id:
      //   apiStudentInfo?.ysb_semester_id ||
      //   childProfile?.ysb_semester_id ||
      //   localStorage.getItem("ysb_semester_id") ||
      //   "",
      ysb_semester_id:
  activeSemesterId ||
  localStorage.getItem("ysb_semester_id") ||
  apiStudentInfo?.ysb_semester_id ||
  childProfile?.ysb_semester_id ||
  "",
      ysb_grade_level_id:
        apiStudentInfo?.ysb_grade_level_id ||
        childProfile?.ysb_grade_level_id ||
        localStorage.getItem("ysb_grade_level_id") ||
        "",
      ysb_kelas_id:
        apiStudentInfo?.ysb_kelas_id ||
        childProfile?.ysb_kelas_id ||
        localStorage.getItem("ysb_kelas_id") ||
        "",
      ysb_teacher_id:
        apiStudentInfo?.ysb_teacher_id ||
        childProfile?.ysb_teacher_id ||
        localStorage.getItem("ysb_teacher_id") ||
        "",
      ysb_teacher_id2:
        apiStudentInfo?.ysb_teacher_id2 ||
        childProfile?.ysb_teacher_id2 ||
        localStorage.getItem("ysb_teacher_id2") ||
        "",
      ysb_student_id,
      ysb_element_id: section?.ysb_element_id || "",
      ysb_sub_element_id: item?.ysb_sub_element_id || "",
      ysb_sub_element_value: value,
      // sesuai contoh screenshot kamu
      user_id: ysb_student_id,
    };

    return payload;
  };

  const saveAnswerToDb = async ({ item, value, section }) => {
    const ysbSubElementId = item?.ysb_sub_element_id;
    if (!ysbSubElementId) return;

    // set loading per item
    setSavingMap((p) => ({ ...(p || {}), [ysbSubElementId]: true }));

    try {
      const payload = buildSavePayload({ item, value, section });

      const isDefault = (item?.id || "default") === "default";

      const API_SAVE_BASE = "/api/angket-otm";
// const API_SAVE_BASE = "https://api.la.sims.alazharsummarecon.sch.id/api/angket-otm";
      const url = isDefault ? `${API_SAVE_BASE}/default` : `${API_SAVE_BASE}/${item.id}`;

      const res = await APILA.put(url, payload, { headers: getAuthHeaders() });

      // Response contoh:
      // create: { data: { id: "...", ysb_sub_element_value: 3 } }
      const returnedId = res?.data?.data?.id;

      // kalau sebelumnya default, simpan id baru ke state agar berikutnya update by ID
      if (isDefault && returnedId) {
        updateItemIdInSections(ysbSubElementId, returnedId);
      }
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "Gagal menyimpan nilai. Silakan coba lagi.";
      bukaModal({
        type: "peringatan",
        title: "Gagal Menyimpan",
        message: msg,
      });

      // rollback ke nilai sebelumnya (opsional, biar user tidak “kecewa”)
      setAnswers((prev) => {
        const next = { ...(prev || {}) };
        // hapus nilai yang barusan dipilih
        delete next[ysbSubElementId];
        return next;
      });
    } finally {
      setSavingMap((p) => ({ ...(p || {}), [ysbSubElementId]: false }));
    }
  };

  const onChooseRating = (item, value, section) => {
    // update UI dulu (responsif)
    setAnswers((prev) => ({ ...(prev || {}), [item.ysb_sub_element_id]: value }));

    // kalau user mulai mengisi, tetap biarkan showMissingMark (supaya yang lain masih merah)
    // tapi pertanyaan ini akan otomatis tidak merah karena sudah ada jawabannya

    // lalu auto-save
    saveAnswerToDb({ item, value, section });
  };

  // ===============================
  // MISSING HELPERS (tanda merah + scroll)
  // ===============================
  const findFirstMissing = () => {
    for (let sIndex = 0; sIndex < (sections || []).length; sIndex++) {
      const sec = sections[sIndex];
      const items = sec?.items || [];
      for (let i = 0; i < items.length; i++) {
        const it = items[i];
        if (!answers?.[it?.ysb_sub_element_id]) {
          return { stepIndex: sIndex, ysb_sub_element_id: it?.ysb_sub_element_id };
        }
      }
    }
    return null;
  };

  const scrollToQuestionById = (ysbSubElementId) => {
    if (!ysbSubElementId) return;

    const el = questionRefs.current?.[ysbSubElementId];
    if (!el) return;

    // scroll halus ke pertanyaan
    el.scrollIntoView({ behavior: "smooth", block: "center" });

    // kasih highlight sebentar biar keliatan fokusnya
    el.classList?.add?.("missing-flash");
    setTimeout(() => {
      el.classList?.remove?.("missing-flash");
    }, 900);
  };

  // ketika step berubah dan ada pendingScrollId, lakukan scroll setelah render
  useEffect(() => {
    if (!pendingScrollId) return;

    // tunggu DOM render
    const t = setTimeout(() => {
      scrollToQuestionById(pendingScrollId);
      setPendingScrollId(null);
    }, 80);

    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step, pendingScrollId, sections]);

  // NOTE:
  // Endpoint submit final belum kamu kasih (kamu cuma minta modal konfirmasi).
  // Jadi alur kirim: modal konfirmasi -> jalankan submitLocal (yang sudah ada) -> tampil modalNotif yang sama seperti sebelumnya.
  const submitLocal = async () => {
    setLoadingAction("submit");
    try {
      if (answeredCount < totalQuestions) {
        // modal "Jawaban Belum Lengkap" -> saat user klik Oke, barulah kasih tanda merah + auto scroll
        bukaModal({
          type: "peringatan",
          title: "Jawaban Belum Lengkap",
          message: `Masih ada jawaban kosong (${answeredCount}/${totalQuestions}). Silakan lengkapi terlebih dahulu.`,
          onConfirm: () => {
            // tutup modal dulu
            tutupModal();

            // aktifkan tanda merah
            setShowMissingMark(true);

            // cari pertanyaan kosong pertama (bisa beda step)
            const first = findFirstMissing();
            if (first?.stepIndex !== undefined && first?.ysb_sub_element_id) {
              // pindah step dulu baru scroll
              setStep(first.stepIndex);
              setPendingScrollId(first.ysb_sub_element_id);
            }
          },
        });
        return;
      }

      // Kalau kamu sudah ada endpoint submit, ganti logika di sini jadi axios.post/put.
      console.log("SUBMIT (sementara lokal) payload:", {
        student_info: apiStudentInfo,
        jawaban: answers,
        catatan_orang_tua: catatan,
      });

      localStorage.removeItem("draft_angket_otm");

      bukaModal({
        type: "sukses",
        title: "Penilaian Terkirim",
        message: "Terima kasih. Penilaian sudah dikirim. Jika sudah dikirim, nilai tidak dapat diubah.",
        onConfirm: () => navigate("/dashboard-parent"),
      });
    } finally {
      setLoadingAction(null);
    }
  };

  const handleClickKirim = () => {
    bukaConfirm({
      title: "Konfirmasi Kirim Penilaian",
      message:
        "Apakah Anda sudah yakin dengan penilaian yang diberikan?\nJika Anda memilih YA, maka Anda tidak akan bisa mengubah nilai tersebut.",
      onConfirm: () => {
        tutupConfirm();
        submitLocal();
      },
    });
  };

  return (
    <div style={styles.page}>
      <Header />

      <main style={styles.container}>
        {/* Header */}
        <section style={{ marginBottom: 16 }}>
          <h1 style={styles.pageTitle}>Penilaian Orang Tua</h1>
          <section style={styles.guideCard}>
            <h4 style={styles.guideTitle}>Panduan Penilaian</h4>
            <ul style={styles.guideList}>
              <li>Isi penilaian sesuai kondisi kebiasaan anak di rumah dan keseharian.</li>
              <li>Gunakan skala 1–4 secara konsisten pada setiap pernyataan.</li>
              <li>Pastikan semua pernyataan sudah terisi sebelum kirim.</li>
              <li>Data penilaian digunakan untuk pembinaan karakter siswa.</li>
            </ul>
          </section>

          <div style={styles.studentBadgeWrap}>
            <span style={styles.studentBadge}>Nama Anak: {namaAnak}</span>
            <span style={styles.studentBadge}>NISN: {nisnAnak}</span>
          </div>
        </section>

        {/* Loading Page */}
        {loadingPage ? (
          <section style={styles.loadingWrap}>
            <PulseLoader size={12} />
            <div style={styles.loadingText}>Memuat pertanyaan...</div>
          </section>
        ) : sections.length === 0 ? (
          <section style={styles.emptyWrap}>
            <div style={styles.emptyTitle}>Data pertanyaan tidak tersedia</div>
            <div style={styles.emptySub}>Coba muat ulang.</div>
            <Button color="primary" onClick={fetchQuestions} style={styles.btnPrimary}>
              Muat Ulang
            </Button>
          </section>
        ) : (
          <>
            {/* Progress */}
            <section style={styles.progressCard}>
              <div style={styles.progressHead}>
                <span style={styles.progressLabel}>Progres</span>
                <span style={styles.progressStep}>
                  Langkah {step + 1} dari {sections.length}
                </span>
              </div>
              <div style={styles.progressTrack}>
                <div style={{ ...styles.progressFill, width: `${progressPercent}%` }} />
              </div>
              <div style={styles.progressMini}>
                Terjawab: {answeredCount}/{totalQuestions}
              </div>
            </section>

            {/* Form Card */}
            <section style={styles.formCard}>
              <h2 style={styles.sectionTitle}>{currentSection.section}</h2>
              <p style={styles.sectionSub}>{currentSection.subtitle} </p>

              {currentSection.items.map((item) => {
                const isSaving = !!savingMap?.[item.ysb_sub_element_id];
                const isMissing = showMissingMark && !answers?.[item.ysb_sub_element_id];

                return (
                  <div
                    key={item.key}
                    ref={(el) => {
                      if (el) questionRefs.current[item.ysb_sub_element_id] = el;
                    }}
                    style={{
                      ...styles.questionWrap,
                      ...(isMissing ? styles.questionWrapMissing : {}),
                    }}
                  >
                    <h3
                      className="question-title"
                      style={{
                        ...styles.questionTitle,
                        ...(isMissing ? styles.questionTitleMissing : {}),
                      }}
                    >
                      {item.title}
                    </h3>

                    <div style={styles.ratingGrid}>
                      {RATING_OPTIONS.map((opt) => {
                        const active = answers?.[item.ysb_sub_element_id] === opt.value;

                        return (
                          <button
                            key={opt.value}
                            type="button"
                            onClick={() => onChooseRating(item, opt.value, currentSection)}
                            disabled={isSaving}
                            style={{
                              ...styles.rateBtn,
                              ...(active ? styles.rateBtnActive : {}),
                              ...(isSaving ? styles.rateBtnDisabled : {}),
                              ...(isMissing ? styles.rateBtnMissing : {}),
                              ...(isMissing && active ? styles.rateBtnActive : {}),
                            }}
                            title={opt.label}
                          >
                            <div className="rate-num" style={{marginTop: "12px"}}>{opt.value} </div>
                            {/* {isSaving && active ? <div style={styles.savingText}>Menyimpan</div> : <></>} */}

                             {isSaving && active ? (
                              <div style={styles.savingText}>Menyimpan</div>
                            ) : (
                              <div style={styles.rateLabel} >{opt.label}</div>
                            )}

                          </button>
                        );
                      })}
                    </div>

                    {/* hint kecil kalau missing */}
                    {/* {isMissing && <div style={styles.missingHint}>Wajib diisi</div>} */}
                  </div>
                );
              })}

              {/* footer buttons */}
              <div style={styles.formFooter}>
                <Button
                  color="light"
                  disabled={isFirstStep || loadingAction !== null}
                  onClick={() => setStep((s) => Math.max(0, s - 1))}
                  style={styles.btnPrev}
                >
                  ‹ Sebelumnya
                </Button>

                {isLastStep ? (
                  <Button
                    color="primary"
                    onClick={handleClickKirim}
                    disabled={loadingAction !== null}
                    style={styles.btnPrimary}
                  >
                    {loadingAction === "submit" ? (
                      "Mengirim..."
                    ) : (
                      <>
                        <FontAwesomeIcon icon={faPaperPlane} style={{ marginRight: 8 }} />
                        Kirim Penilaian
                      </>
                    )}
                  </Button>
                ) : (
                  <Button
                    color="primary"
                    onClick={() => setStep((s) => Math.min(sections.length - 1, s + 1))}
                    disabled={loadingAction !== null}
                    style={styles.btnPrimary}
                  >
                    Berikutnya ›
                  </Button>
                )}
              </div>

              <p style={styles.counterInfo}>
                Selesai di bagian ini: {sectionAnswered}/{currentSection.items.length} • Total terjawab:{" "}
                {answeredCount}/{totalQuestions}
              </p>
            </section>
          </>
        )}
      </main>

      {/* Modal Konfirmasi Kirim */}
      {confirmModal.open && (
        <div style={styles.modalOverlay}>
          <div style={{ ...styles.modalCard, textAlign: "left" }}>
            <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
              <div style={{ ...styles.confirmIcon }}>!</div>
              <div style={{ flex: 1 }}>
                <h3 style={{ ...styles.modalTitle, marginBottom: 6 }}>{confirmModal.title}</h3>
                <p style={{ ...styles.modalMessage, whiteSpace: "pre-line" }}>{confirmModal.message}</p>
              </div>
            </div>

            <div style={styles.confirmActions}>
              <button type="button" style={styles.modalBtnGhost} onClick={tutupConfirm}>
                Batal
              </button>
              <button
                type="button"
                style={styles.modalBtnPrimary}
                onClick={() => {
                  const cb = confirmModal.onConfirm;
                  if (cb) cb();
                }}
              >
                Ya, Kirim
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Notif (yang sudah ada - tetap sama) */}
      {modalNotif.open && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalCard}>
            <div
              style={{
                ...styles.modalIcon,
                ...(modalNotif.type === "sukses"
                  ? styles.modalIconSuccess
                  : modalNotif.type === "peringatan"
                  ? styles.modalIconWarning
                  : styles.modalIconInfo),
              }}
            >
              {modalNotif.type === "sukses" ? "✓" : modalNotif.type === "peringatan" ? "!" : "i"}
            </div>

            <h3 style={styles.modalTitle}>{modalNotif.title}</h3>
            <p style={styles.modalMessage}>{modalNotif.message}</p>

            <div style={styles.modalActions}>
              <button
                type="button"
                style={styles.modalBtnPrimary}
                onClick={() => {
                  const cb = modalNotif.onConfirm;
                  tutupModal();
                  if (cb) cb();
                }}
              >
                Oke, Mengerti
              </button>
            </div>
          </div>
        </div>
      )}

      {/* tiny CSS injection biar flash highlight jalan tanpa ganggu file css lain */}
      <style>{`
        .missing-flash {
          animation: missingFlash 0.9s ease-in-out 1;
        }
        @keyframes missingFlash {
          0% { box-shadow: 0 0 0 rgba(239,68,68,0); }
          40% { box-shadow: 0 0 0 6px rgba(239,68,68,0.18); }
          100% { box-shadow: 0 0 0 rgba(239,68,68,0); }
        }
      `}</style>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "#F3F4F6",
    fontFamily:
      'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    color: "#111827",
  },
  topbar: {
    height: 74,
    background: "#FFFFFF",
    borderBottom: "1px solid #E5E7EB",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 22px",
    position: "sticky",
    top: 0,
    zIndex: 20,
  },
  brandWrap: { display: "flex", alignItems: "center", gap: 10 },
  brandIcon: {
    width: 32,
    height: 32,
    borderRadius: 8,
    background: "#EEF2FF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  brandText: { fontSize: 20, fontWeight: 700, color: "#1F2937" },
  topbarRight: { display: "flex", alignItems: "center", gap: 12 },
  iconBtn: {
    width: 36,
    height: 36,
    borderRadius: 10,
    border: "1px solid #E5E7EB",
    background: "#fff",
  },
  userBox: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "6px 10px",
    border: "1px solid #E5E7EB",
    borderRadius: 12,
    background: "#FFFFFF",
  },
  userAvatar: {
    width: 30,
    height: 30,
    borderRadius: "50%",
    background: "#F3F4F6",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  userName: { fontSize: 13, fontWeight: 700, lineHeight: 1.2 },
  userRole: { fontSize: 12, color: "#6B7280" },
  logoutBtn: {
    border: "none",
    background: "transparent",
    color: "#EF4444",
    fontWeight: 700,
    cursor: "pointer",
  },

  container: { maxWidth: 980, margin: "0 auto", padding: "26px 16px 30px" },

  pageTitle: { margin: 0, fontSize: 42, fontWeight: 800 },

  studentBadgeWrap: {
    marginTop: 10,
    display: "flex",
    gap: 8,
    flexWrap: "wrap",
  },
  studentBadge: {
    background: "#EEF2FF",
    color: "#4338CA",
    border: "1px solid #C7D2FE",
    borderRadius: 999,
    fontWeight: 700,
    fontSize: 12,
    padding: "5px 10px",
  },

  loadingWrap: {
    background: "#fff",
    border: "1px solid #E5E7EB",
    borderRadius: 12,
    padding: 22,
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
  loadingText: { fontSize: 14, color: "#6B7280", fontWeight: 700 },

  emptyWrap: {
    background: "#fff",
    border: "1px solid #E5E7EB",
    borderRadius: 12,
    padding: 22,
  },
  emptyTitle: { fontSize: 18, fontWeight: 800 },
  emptySub: { marginTop: 6, color: "#6B7280", fontWeight: 600 },

  progressCard: {
    background: "#fff",
    border: "1px solid #E5E7EB",
    borderRadius: 12,
    padding: 16,
    marginBottom: 16,
  },
  progressHead: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
  },
  progressLabel: { fontSize: 16, fontWeight: 700 },
  progressStep: { fontSize: 14, color: "#6B7280", fontWeight: 600 },
  progressTrack: {
    height: 8,
    width: "100%",
    borderRadius: 999,
    background: "#E5E7EB",
    overflow: "hidden",
  },
  progressFill: {
    height: "100%",
    borderRadius: 999,
    background: "#4F46E5",
    transition: "width .25s ease",
  },
  progressMini: { marginTop: 10, fontSize: 13, color: "#6B7280", fontWeight: 700 },

  formCard: {
    background: "#fff",
    border: "1px solid #E5E7EB",
    borderRadius: 12,
    padding: 22,
    marginBottom: 16,
  },
  sectionTitle: { margin: 0, fontSize: 24, fontWeight: 800, color: "#403abc" },
  sectionSub: { marginTop: 4, color: "#6B7280", fontSize: 15 },

  questionWrap: { padding: "16px 0", borderBottom: "1px solid #E5E7EB" },
  questionTitle: { margin: 0, fontSize: 18, fontWeight: 700 },

  // === MISSING STYLE ===
  questionWrapMissing: {
    // borderBottom: "1px solid #FCA5A5",
    // background: "rgba(254,226,226,0.35)",
    // borderRadius: 10,
    // padding: "16px 12px",
    // margin: "10px 0",
  },
  questionTitleMissing: {
    color: "#B91C1C",
  },
  rateBtnMissing: {
    border: "1px solid #FCA5A5",
    // background: "rgba(254,226,226,0.45)",
  },
  missingHint: {
    marginTop: 10,
    fontSize: 12,
    fontWeight: 800,
    color: "#B91C1C",
  },

  ratingGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(20px, 1fr))",
    gap: 10,
    marginTop: 12,
  },
  rateBtn: {
    border: "1px solid #D1D5DB",
    background: "#fff",
    borderRadius: 8,
    padding: "8px 6px",
    cursor: "pointer",
    minHeight: 56,
    position: "relative",
  },
  rateBtnDisabled: {
    opacity: 0.7,
    cursor: "not-allowed",
  },
  rateBtnActive: {
    border: "2px solid #4F46E5",
    boxShadow: "0 0 0 2px rgba(79,70,229,0.12)",
    background: "#EEF2FF",
  },
  rateNum: { fontSize: 20, fontWeight: 800, lineHeight: 1, marginBottom: 0 },
  // rateLabel: { fontSize: 12, fontWeight: 700, color: "#6B7280" },

   rateLabel : {
    marginTop: 15,
fontWeight: 800,
  },
  savingMini: { marginTop: 6 },

  formFooter: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 10,
    marginTop: 16,
  },
  btnPrev: { minWidth: 120, borderRadius: 10, fontWeight: 700 },
  btnPrimary: {
    minWidth: 180,
    borderRadius: 10,
    backgroundColor: "#4F46E5",
    borderColor: "#4F46E5",
    fontWeight: 700,
  },
  counterInfo: { marginTop: 10, fontSize: 13, color: "#6B7280", fontWeight: 600 },

  guideCard: {
    background: "#F9FAFB",
    border: "1px solid #E5E7EB",
    borderRadius: 12,
    padding: 18,
    marginTop: 20,
  },
  guideTitle: { margin: 0, fontSize: 20, fontWeight: 800, color: "#4F46E5" },
  guideList: {
    margin: "10px 0 0",
    paddingLeft: 18,
    color: "#6B7280",
    lineHeight: 1.85,
    fontSize: 15,
  },

  modalOverlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(17,24,39,0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    padding: 16,
  },
  modalCard: {
    width: "100%",
    maxWidth: 420,
    background: "#FFFFFF",
    borderRadius: 16,
    border: "1px solid #E5E7EB",
    boxShadow: "0 20px 45px rgba(0,0,0,0.22)",
    padding: "22px 20px 18px",
    textAlign: "center",
  },

  // modal notif existing
  modalIcon: {
    width: 56,
    height: 56,
    borderRadius: "50%",
    margin: "0 auto 12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 28,
    fontWeight: 800,
  },
  modalIconSuccess: { background: "#DCFCE7", color: "#166534" },
  modalIconWarning: { background: "#FEF3C7", color: "#92400E" },
  modalIconInfo: { background: "#DBEAFE", color: "#1D4ED8" },
  modalTitle: { margin: "0 0 6px", fontSize: 22, fontWeight: 800, color: "#111827" },
  modalMessage: { margin: 0, fontSize: 14, lineHeight: 1.6, color: "#4B5563" },
  modalActions: { marginTop: 16, display: "flex", justifyContent: "center" },
  modalBtnPrimary: {
    border: "none",
    background: "#4F46E5",
    color: "#fff",
    fontWeight: 700,
    borderRadius: 10,
    padding: "10px 16px",
    minWidth: 140,
    cursor: "pointer",
  },

  // confirm modal (baru)
  confirmIcon: {
    width: 44,
    height: 44,
    borderRadius: 12,
    background: "#FEF3C7",
    color: "#92400E",
    fontWeight: 900,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 20,
    marginTop: 2,
  },
  confirmActions: {
    marginTop: 18,
    display: "flex",
    gap: 10,
    justifyContent: "flex-end",
  },
  modalBtnGhost: {
    border: "1px solid #E5E7EB",
    background: "#fff",
    color: "#111827",
    fontWeight: 800,
    borderRadius: 10,
    padding: "10px 14px",
    minWidth: 110,
    cursor: "pointer",
  },
  savingText: {
    marginTop: 6,
    fontSize: 10,
    fontWeight: 700,
    color: "#6B7280",
  },
};